import { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux';
import { HeaderWrapper } from './components/header'
// import {RightToolbar} from '../partials/layout/RightToolbar'
import { ScrollTop } from './components/scroll-top'
import { Content } from './components/content'
import { FooterWrapper } from './components/footer'
import { Sidebar } from './components/sidebar'
import {
  // DrawerMessenger,
  // ActivityDrawer,
  // InviteUsers,
  // UpgradePlan,
  ThemeModeProvider,
} from '../partials'
import { PageDataProvider } from './core'
import { reInitMenu } from '../helpers'
// import {ToolbarWrapper} from './components/toolbar'

const MasterLayout = () => {
  const location = useLocation();
  const dispatch = useDispatch()
  const [animationClass, setAnimationClass] = useState('')
  const [loggingOut, setLoggingOut] = useState(false)
  useEffect(() => {
    setAnimationClass('fade-exit')
    const timeout = setTimeout(() => {
      setAnimationClass('fade-enter')
    }, 150) // Match the duration of your CSS animation

    return () => clearTimeout(timeout)
  }, [location.pathname])

  useEffect(() => {
    reInitMenu()
  }, [location.key])

  const handleLogoutAnimation = () => {
    setLoggingOut(true);
    setTimeout(() => {
      // Perform logout after animation
      dispatch({ type: 'USER_LOGOUT' });
    }, 1000); // Match the duration of your CSS animation for logout
  };
  
  return (
    <PageDataProvider>
      <ThemeModeProvider>
        <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
          <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>  
            <div className={`app-wrapper flex-column flex-row-fluid ${loggingOut ? 'logoutAnimation' : '' }`} id='kt_app_wrapper'>
              <Sidebar />
              <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
                <div className='d-flex flex-column flex-column-fluid'>
                  {/* <ToolbarWrapper /> */}
                  <HeaderWrapper onLogout={handleLogoutAnimation} />
                  <div className={animationClass}> 
                  <Content>
                    <Outlet />
                  </Content>
                  </div>    
                </div>
                {/* {location.pathname === '/dashboard' ? null : <FooterWrapper />} */}
                <FooterWrapper />
              </div>
            </div>
          </div>
        </div>

        {/* begin:: Drawers */}
        {/* <ActivityDrawer /> */}
        {/* <RightToolbar /> */}
        {/* <DrawerMessenger /> */}
        {/* end:: Drawers */}

        {/* begin:: Modals */}
        {/* <InviteUsers /> */}
        {/* <UpgradePlan /> */}
        {/* end:: Modals */}
        <ScrollTop />
      </ThemeModeProvider>
    </PageDataProvider>
  )
}

export { MasterLayout }
